import swal from "sweetalert";
import { BACKEND } from "../context/backend";

export function getVisitasService(authTokens) {
  // Funcion que pide el listado de todas las visitas a la db.
  return fetch(BACKEND + "/api/visitas/", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    },
  }).then((data) => data.json());
}

export function createVisitaService(newVisita, authTokens) {
  // Funcion que crea una nueva visita en la db.
  const body = JSON.stringify(newVisita);

  return fetch(BACKEND + "/api/visitas/", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    },
    body,
  }).then((response) => {
    if (response.status === 200) {
      swal("Visita registrada!", {
        button: false,
        icon: "success",
        timer: "2000",
      });
      return response.json();
    } else {
      swal("Algo salio mal", {
        button: false,
        icon: "error",
        timer: "1500",
      });
    }
  });
}

export function deleteVisitaService(id, authTokens) {
  // Funcion que se encarga de eliminar a una Visita pasandole su id.
  return fetch(BACKEND + `/api/visita/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    },
  }).then((data) => data.json());
}

export function getOneVisitaService(id, authTokens) {
  return fetch(BACKEND + `/api/visita/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    },
  }).then((data) => data.json());
}

export function updateOneVisitaService(request, authTokens) {

  const body = JSON.stringify(request.formaDePago);

  return fetch(BACKEND + `/api/visita/${request.id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    }, 
    body
  }).then((response) => {
    if (response.status === 200) {
      swal("Visita actualizada!", {
        button: false,
        icon: "success",
        timer: "1500",
      });
      return response
    } else {
      swal("Algo salio mal", {
        button: false,
        icon: "error",
        timer: "1500",
      });
    }
  });
}
